module.exports = __webpack_public_path__ + "img/colorBox8.f0efcea4.jpg";